var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "256px",
    width: "256px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 487.189 487.189",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M470.766,201.645H328.514c-0.679,12.523-5.831,23.854-14.075,32.277h140.188v107.525l-16.752-58.983 c-1.971-6.934-8.307-11.726-15.525-11.726H80.981v-89.762h98.881v-32.277H64.843c-8.92,0-16.139,7.225-16.139,16.139v105.9H16.427 c-5.059,0-9.834,2.371-12.877,6.406c-3.057,4.043-4.033,9.276-2.647,14.146l46.049,162.18 c3.374,11.881,14.224,20.077,26.574,20.075l385.762-0.065c15.253-0.003,27.615-12.368,27.615-27.62V217.783 C486.903,208.871,479.687,201.645,470.766,201.645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.902,487.174v-0.14C486.836,487.162,486.828,487.219,486.902,487.174z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.373,101.74h32.766v97.171c0,9.865,7.975,17.848,17.824,17.848h48.699c9.867,0,17.857-7.982,17.857-17.848V101.74 h32.75c5.404,0,10.305-3.27,12.387-8.282c2.064-4.988,0.932-10.756-2.914-14.594L263.783,3.931C261.184,1.314,257.748,0,254.313,0 c-3.42,0-6.855,1.314-9.473,3.931l-74.924,74.934c-3.861,3.838-4.98,9.605-2.898,14.594 C169.098,98.471,173.967,101.74,179.373,101.74z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFolder);
export default __webpack_public_path__ + "static/media/upload-folder.ebe424129803dd8e9e1fbd2bd5294875.svg";
export { ForwardRef as ReactComponent };